import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles/styles.module.scss';
import baseStyles from '../../../../styles/baseStyles.module.scss';
import buttonStyles from '../../buttons/styles/styles.module.scss';

import { ProPageStrings } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const CurrencyFormatter = require('currency-formatter');

const PlanTypeCard = ({ option, handler, isActive, currencyCode, isCouponApplied, verifiedCoupon, staticCard, extraClasses }) => {
  const formatCurrency = number => {
    return CurrencyFormatter.format(number, { code: currencyCode });
  };

  const enterKeyHandler = event => {
    if (event.key === 'Enter') {
      handler();
    }
  };

  const plan = JSON.parse(JSON.stringify(option));

  if (isCouponApplied && verifiedCoupon && option.allowCoupon) {
    plan.showDiscount = true;
    plan.discountAmount = `${verifiedCoupon.discountPercentage}% Off`; // Note that for now there are only percentage discounts.
    plan.priceTotal = verifiedCoupon.discountedPricePerYear;
    plan.priceMonth = verifiedCoupon.discountedPricePerYear / 12;
  } else if (plan.discountOverride) {
    plan.showDiscount = true;
    plan.discountAmount = plan.discountOverrideAmount;
  } else if (ProPageStrings.discountText[plan.planCode]) {
    // need to always render a "discount" for the 3 year plan
    plan.discountAmount = ProPageStrings.discountText[plan.planCode];
  }

  let discount;
  let billedAtLang = ProPageStrings.planDetails[plan.planCode];
  if (plan.showDiscount) {
    // billing language is slightly different when discounting first year
    discount = <div className={styles.discount}>{plan.discountAmount}</div>;
    if (plan.planCode === 'annual') {
      billedAtLang = ProPageStrings.planDetails.annualDiscounted;
    }
  }

  return (
    <div
      tabIndex={staticCard ? '-1' : '0'}
      onClick={handler}
      onKeyPress={enterKeyHandler}
      role="button"
      className={`${isActive ? styles.active : ''} ${!handler ? styles.static : ''} ${buttonStyles.button} ${styles.card} ${extraClasses}`}
    >
      <div className={styles.contents}>
        <div className={styles.label}>
          <div className={styles.plan}>{ProPageStrings.planTypeTitles[plan.planCode]}</div>
          {discount}
        </div>
        <div className={(baseStyles.row, styles.details)}>
          {formatCurrency(plan.priceMonth)} {billedAtLang} {formatCurrency(plan.priceTotal)}
        </div>
      </div>
    </div>
  );
};

PlanTypeCard.defaultProps = {
  isActive: false,
  extraClasses: PropTypes.string
};

PlanTypeCard.propTypes = {
  option: PropTypes.shape({
    discountAmount: PropTypes.string,
    showDiscount: PropTypes.bool,
    allowCoupon: PropTypes.bool
  }).isRequired,
  isActive: PropTypes.bool,
  extraClasses: PropTypes.string
};

export default PlanTypeCard;
